module.exports = __webpack_public_path__ + "img/horizontal_4_1_5010.93d9b1ef.png";